export default {
    methods: {
        slugify(string) {
            const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
            const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
            const p = new RegExp(a.split('').join('|'), 'g');
            return string.toString().toLowerCase().trim()
                .replace(/\s+/g, '-')
                .replace(p, c => b.charAt(a.indexOf(c)))
                .replace(/&/g, '-and-')
                .replace(/[^\w\-]+/g, '')
                .replace(/\-\-+/g, '-')
                .replace(/^-+/, '');
        },
        uppercase(string) {
            return string.toString().toUpperCase();
        },
        lowercase(string) {
            return string.toString().toLowerCase();
        },
        camelCase(string) {
            return string.toString().trim()
                .replace(/\s(.)/g, function ($1) {
                    return $1.toUpperCase();
                })
                .replace(/\s/g, '')
                .replace(/^(.)/, function ($1) {
                    return $1.toLowerCase();
                });
        },
        snakeCase(string) {
            return string.toString().toLowerCase().trim().replace(/\s+/g, '_');
        },
        ucFirst(string) {
            return string.toString().charAt(0).toUpperCase() + string.toString().slice(1);
        },
        truncate(string, length, suffix) {
            if (string.length > length) {
                return string.toString().substring(0, length) + suffix;
            } else {
                return string;
            }
        }
    }
};
